import React, {  useState, useEffect } from "react";
import { fetchJSON } from "helpers/axios";
import { useLocation } from "react-router-dom";
import GeneralPaymentReceipt from "./GeneralPaymentReceipt";
import SchoolFeesPaymentReceipt from "./SchoolFeesPaymentReceipt";

const PaymentReceipt = () => {
  const location = useLocation();
  // const url = window.location.href;
  const url = location.search;
  // let urlParams = new URLSearchParams(url);
  // const payeeId = urlParams.get("applicantId");
  const transactionId = url !== "" ? url?.match(/transactionId=(.*)/)[1] : "";

  if (transactionId == "") {
    window.location.href = "/portal";
  }

  const [paymentReceipt, setPaymentReceipt] = useState([]);

  useEffect(async () => {
    try {
      const response = await fetchJSON(
        `api/PaymentReceiptByRRR?transactionId=${transactionId}`,
        null,
        "GET"
      );
      await setPaymentReceipt(response);
    } catch (error) {
      console.log(error);
    }
  }, [paymentReceipt]);

  return (
    <>
      {paymentReceipt?.paymentCategoryId ? (
        <SchoolFeesPaymentReceipt TransactionId={transactionId} paymentReceipt={paymentReceipt} />) : (
        <GeneralPaymentReceipt transactionId={transactionId} paymentReceipt={paymentReceipt} />
      )}
      
    </>
  );
};

export default PaymentReceipt;
